import buildUrlParams from 'js-core/js/utils/buildUrlParams';

export default{

    methods: {

        getExportUrl(path, params = {}) {

            const token = this.$auth.getSession().getToken();

            const fullParams = {
                ...params,
                token
            };

            return this.$di.config.apiUrl + '/export/' + path + '?' + buildUrlParams(fullParams);
        },

        navigateExport(path, params = {}) {

            document.location = this.getExportUrl(path, params);
        }
    }
};
